const MultipleUsersIcon = ({
  className,
  strokeWidth = 2
}: {
  className?: string;
  strokeWidth?: number;
}) => (
  <svg
    width="22"
    height="18"
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16 17H21V15C21 14.3765 20.8057 13.7686 20.4441 13.2606C20.0826 12.7527 19.5718 12.37 18.9827 12.1658C18.3937 11.9615 17.7556 11.9459 17.1573 12.121C16.5589 12.2962 16.03 12.6534 15.644 13.143M16 17H6M16 17V15C16 14.344 15.874 13.717 15.644 13.143M15.644 13.143C15.2726 12.215 14.6318 11.4195 13.804 10.8591C12.9762 10.2988 11.9996 9.9993 11 9.9993C10.0004 9.9993 9.02376 10.2988 8.196 10.8591C7.36825 11.4195 6.72736 12.215 6.356 13.143M6 17H1V15C1.00005 14.3765 1.19434 13.7686 1.55586 13.2606C1.91739 12.7527 2.42819 12.37 3.01725 12.1658C3.60632 11.9615 4.24438 11.9459 4.84274 12.121C5.4411 12.2962 5.97003 12.6534 6.356 13.143M6 17V15C6 14.344 6.126 13.717 6.356 13.143M14 4C14 4.79565 13.6839 5.55871 13.1213 6.12132C12.5587 6.68393 11.7956 7 11 7C10.2044 7 9.44129 6.68393 8.87868 6.12132C8.31607 5.55871 8 4.79565 8 4C8 3.20435 8.31607 2.44129 8.87868 1.87868C9.44129 1.31607 10.2044 1 11 1C11.7956 1 12.5587 1.31607 13.1213 1.87868C13.6839 2.44129 14 3.20435 14 4ZM20 7C20 7.53043 19.7893 8.03914 19.4142 8.41421C19.0391 8.78929 18.5304 9 18 9C17.4696 9 16.9609 8.78929 16.5858 8.41421C16.2107 8.03914 16 7.53043 16 7C16 6.46957 16.2107 5.96086 16.5858 5.58579C16.9609 5.21071 17.4696 5 18 5C18.5304 5 19.0391 5.21071 19.4142 5.58579C19.7893 5.96086 20 6.46957 20 7ZM6 7C6 7.53043 5.78929 8.03914 5.41421 8.41421C5.03914 8.78929 4.53043 9 4 9C3.46957 9 2.96086 8.78929 2.58579 8.41421C2.21071 8.03914 2 7.53043 2 7C2 6.46957 2.21071 5.96086 2.58579 5.58579C2.96086 5.21071 3.46957 5 4 5C4.53043 5 5.03914 5.21071 5.41421 5.58579C5.78929 5.96086 6 6.46957 6 7Z"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MultipleUsersIcon;
